export const PaymentType = {
  CARD: 'CARD',
  WALLET: 'WALLET',
  NONE: 'NONE',
} as const

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType]

export const BranchDirectCardStatus = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
  NONE: 'NONE',
} as const

export type BranchDirectCardStatus =
  (typeof BranchDirectCardStatus)[keyof typeof BranchDirectCardStatus]

export const WalletStatus = {
  NOT_CREATED: 'NOT_CREATED',
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  REVIEW: 'REVIEW',
  UNCLAIMED: 'UNCLAIMED',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  FAILED: 'FAILED',
  CLOSED: 'CLOSED',
} as const

export type WalletStatus = (typeof WalletStatus)[keyof typeof WalletStatus]

export type UpdatePaymentProfileRequest = {
  active_type: PaymentType
  from_type?: PaymentType
}

export type PaymentProfile = {
  type: PaymentType
  ref: string
}

export type WalletAccountTypes = 'STANDARD' | 'PAYCARD' | 'MINOR' | 'RESTRICTED'

export const walletAccountTypeMap: Partial<Record<WalletAccountTypes, string>> =
  {
    STANDARD: 'Premier',
    PAYCARD: 'Essential',
    MINOR: 'Minor',
    RESTRICTED: 'Restricted',
  }

export type PaymentProfileWallet = {
  wallet_id: number
  account_number: string
  routing_number: string
  status: WalletStatus
  account_type: WalletAccountTypes
}

export type PaymentProfileBranchDirectCardAccount = {
  id: number
  network: string
  last4: string
  expiration: string
  time_created: string
}

export type PaymentProfileBranchDirectBankAccount = {
  ach_account_id: number
  ach_funding_source_id: number
  account_number_last_four: string
  account_name: string
  time_created: string
  verified: boolean
}
export type PaymentProfileResponse = {
  wallet: PaymentProfileWallet
  branch_direct_card_account: PaymentProfileBranchDirectCardAccount
  branch_direct_bank_account: PaymentProfileBranchDirectBankAccount
  active_type: PaymentType
}
